import { ButtonSize } from '../button.models';

/**
 * Size configuration for button dimensions and spacing
 */
export interface SizeConfig {
  /** Height class */
  height: string;
  /** Width classes for different button types */
  width: {
    /** Width for icon-only buttons */
    iconOnly: string;
    /** Width for regular buttons */
    regular: string;
  };
  /** Horizontal padding classes */
  padding: {
    /** Padding for center-aligned buttons */
    regular: string;
    /** Padding for left-aligned buttons */
    alignLeft: string;
  };
  /** Text size class */
  text: string;
  /** Gap between icon and text */
  gap: string;
}

/**
 * Complete size configuration for all button sizes.
 * All CSS classes are statically defined for Tailwind CSS 4 compatibility.
 */
export const SIZE_CONFIG: Record<ButtonSize, SizeConfig> = {
  xs: {
    height: 'min-h-7',
    width: {
      iconOnly: 'w-7',
      regular: 'w-full',
    },
    padding: {
      regular: 'px-2',
      alignLeft: 'px-2',
    },
    text: 'text-sm',
    gap: 'gap-1',
  },
  small: {
    height: 'min-h-8',
    width: {
      iconOnly: 'w-8',
      regular: 'w-full',
    },
    padding: {
      regular: 'px-3',
      alignLeft: 'px-4',
    },
    text: 'text-sm',
    gap: 'gap-1.5',
  },
  medium: {
    height: 'min-h-9',
    width: {
      iconOnly: 'w-9',
      regular: 'w-full',
    },
    padding: {
      regular: 'px-3',
      alignLeft: 'px-4',
    },
    text: 'text-sm',
    gap: 'gap-2',
  },
  large: {
    height: 'min-h-10',
    width: {
      iconOnly: 'w-10',
      regular: 'w-full',
    },
    padding: {
      regular: 'px-3',
      alignLeft: 'px-4',
    },
    text: 'text-base',
    gap: 'gap-2',
  },
  xl: {
    height: 'min-h-12',
    width: {
      iconOnly: 'w-12',
      regular: 'w-full',
    },
    padding: {
      regular: 'px-3',
      alignLeft: 'px-4',
    },
    text: 'text-base',
    gap: 'gap-2',
  },
  '2xl': {
    height: 'min-h-16',
    width: {
      iconOnly: 'w-16',
      regular: 'w-full',
    },
    padding: {
      regular: 'px-3',
      alignLeft: 'px-4',
    },
    text: 'text-base',
    gap: 'gap-2',
  },
  '3xl': {
    height: 'min-h-24',
    width: {
      iconOnly: 'w-24',
      regular: 'w-full',
    },
    padding: {
      regular: 'px-3',
      alignLeft: 'px-4',
    },
    text: 'text-base',
    gap: 'gap-2',
  },
  '4xl': {
    height: 'min-h-38',
    width: {
      iconOnly: 'w-38',
      regular: 'w-full',
    },
    padding: {
      regular: 'px-3',
      alignLeft: 'px-4',
    },
    text: 'text-base',
    gap: 'gap-2',
  },
};
